export const searchTabOptions = [
  {
    id: 0,
    label: 'All',
  },
  {
    id: 1,
    label: 'Candidates',
  },
  {
    id: 2,
    label: 'Flow',
  },
  {
    id: 3,
    label: 'Jobs',
  },
];
